import React, { Fragment } from 'react';
import Modal from 'react-modal';
import Sticky from 'react-stickynode';
import { Helmet } from 'react-helmet';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { slugify } from '../helpers';
import Header from './Header';
import Hero from './Hero';
import MainSub from './MainSub';
import Footer from './Footer';
import Toast from './Toast';
import * as actionCreators from '../actions/actionCreators';

class IndustrySub extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isGuideOpen: false,
      isFilterOpen: false,
      isProductActive: false,
      isIndustryActive: true,
      width: window.innerWidth,
      isInterior: true
    };

    this.toggleGuide = this.toggleGuide.bind(this);
    this.toggleFilter = this.toggleFilter.bind(this);
    this.toggleTabs = this.toggleTabs.bind(this);

    for (let data = this.props.industries, i = 0, l = data.length; i < l; i++) {
      const indus = data[i].id;
      const indusName = data[i].name;
      const squares = [];
      data[i].sectors.forEach(sectors => {
        sectors.parent = indus;
        sectors.parentName = indusName;
        squares.push(sectors.id);
      });
      data[i].squares = squares;
    }

    // Hook for determining parent industry
    this.slug = this.props.match.params.industryId.toString().toLowerCase();

    this.sub = this.props.industries.find(indus => {
      // If current slug = found product's slug
      const san = slugify(indus.name);
      if (san === this.slug) {
        this.name = indus.name;
        this.indusId = indus.id;
      }
    });

    this.sects = this.props.industries
      .map((indus, i) => indus.sectors)
      .reduce((prev, curr) => prev.concat(curr), []);
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentDidMount() {
    const tmp = this;
    setTimeout(() => {
      tmp.loadData();
    }, 2000);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  loadData() {
    // Give sectors parent name & ID, push sectors to props
    for (let data = this.props.industries, i = 0, l = data.length; i < l; i++) {
      const indus = data[i].id;
      const indusName = data[i].name;
      const squares = [];
      data[i].sectors.forEach(sectors => {
        sectors.parent = indus;
        sectors.parentName = indusName;
        squares.push(sectors.id);
      });
      data[i].squares = squares;
    }

    // Hook for determining parent industry
    this.slug = this.props.match.params.industryId.toString().toLowerCase();

    this.sub = this.props.industries.find(indus => {
      // If current slug = found product's slug
      const san = slugify(indus.name);
      if (san === this.slug) {
        this.name = indus.name;
        this.indusId = indus.id;
      }
    });

    // Give industries an array of sector IDs for hook
    this.sects = this.props.industries
      .map((indus, i) => indus.sectors)
      .reduce((prev, curr) => prev.concat(curr), []);

    this.setState({
      industryUpdate: true,
    });
  }

  // Open User Guide/add blur
  toggleGuide() {
    this.setState({
      isGuideOpen: !this.state.isGuideOpen,
    });
  }

  // Toggle filter form
  toggleFilter() {
    this.setState({
      isFilterOpen: !this.state.isFilterOpen,
    });
  }

  // Toggle tabs
  toggleTabs() {
    const { isProductActive, isIndustryActive } = this.state || {};
    this.setState({
      isIndustryActive: !isIndustryActive,
      isProductActive: !isProductActive,
    });
  }

  render() {
    const { width, isInterior, isProductActive, isIndustryActive } = this.state || {};
    const isMobile = width <= 768;

    const {
      toggleGuide,
      toggleFilter,
      toast,
      isGuideOpen,
      isFilterOpen,
      closeModal,
      modalIsOpen,
      bookmarkPage,
      showInstallBanner,
    } = this.props;

    return (
      <Fragment>
        <Helmet>
          <title>{`Chubb CI - ${this.name}`}</title>
          <meta property="og:title" content={`Chubb CI - ${this.name}`} />
          <meta property="og:url" content={window.location} />
          <meta name="twitter:title" content={`Chubb CI - ${this.name}`} />
          <meta name="twitter:url" content={window.location} />
          <link rel="canonical" href={window.location} />
        </Helmet>
        <Sticky enabled top={0} offset={100}>
          <Header
            toggleGuide={toggleGuide}
            isGuideOpen={isGuideOpen}
            closeModal={closeModal}
            modalIsOpen={modalIsOpen}
            guide="User Guide"
            bookmarkPage={bookmarkPage}
          />
          <Hero {...this.props} heading={this.name} isInterior={isInterior} />
        </Sticky>
        <MainSub
          {...this.props}
          parent={this.indusId}
          parentName={this.name}
          slug={this.slug}
          sects={this.sects}
          toggleTabs={this.toggleTabs}
          isProductActive={isProductActive}
          isIndustryActive={isIndustryActive}
          isGuideOpen={isGuideOpen}
          isFilterOpen={isFilterOpen}
          handleMobileFilter={this.handleMobileFilter}
        />
        <Footer feedback="Feedback" />
        {showInstallBanner && <Toast toast={toast} />}
      </Fragment>
    );
  }
}

export default IndustrySub;



// WEBPACK FOOTER //
// ./src/components/IndustrySub.js